<script>
import { InputCheckBox } from '@/components/Input';
import { masterMethods, authFackMethods } from '@/state/helpers';
import { checkPermission, getInfoUserLocalStorage } from '@/utils/handlers';
import { showMessage } from '@/utils/messages';
import { clearInfoUser } from '@/api/handler/main';
import { NAMEROLEFIXED } from '@/config/constants';

import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import LoadingIcon from '@/components/Loading/main.vue';
import Footer from '@/components/Footer/main.vue';

export default {
    page: {
        title: '権限管理一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        LoadingIcon,
        InputCheckBox
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('permission.view')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            emptyData: false,
            listDataPermissionRoles: [],
            listDataPermission: [],
            total: 0,
            limit: 10,
            page: 1,
            disabled: true,
            isLoading: false,
            listNamePermissionEdited: [],
            NAMEROLEFIXED
        };
    },
    mounted() {
        this.getListPermission();
        this.getPermission();
    },
    methods: {
        ...masterMethods,
        ...authFackMethods,

        checkPermiss(listRole) {
            return checkPermission(listRole);
        },
        getListPermission() {
            this.listPermission().then((data) => {
                this.listDataPermissionRoles = data;
            });
        },
        getPermission() {
            this.isLoading = true;
            this.dataPermission().then((data) => {
                for (let element of data) {
                    element.per = {};
                    for (let item of element.permissions) {
                        element.per[item.name + '__' + item.id] = true;
                    }
                }
                this.listDataPermission = data;
                this.isLoading = false;
            });
        },
        goToEdit(path, item) {
            this.$router.push({ path: path, query: { id: item.id } });
        },
        savePermission() {
            let objectData = this.listDataPermission;
            for (let item of objectData) {
                let permissions = item.per;
                item.permissions = [];
                Object.keys(permissions).forEach(function (key) {
                    if (permissions[key]) {
                        let permiss = key.split('__');
                        item.permissions.push(parseInt(permiss[1]));
                    }
                });
            }
            this.registerPermission({ roles: objectData }).then((data) => {
                if (data.code == 200) {
                    showMessage(data.code, this.$bvToast, '権限が更新されました。');
                    const roleName = getInfoUserLocalStorage()?.role?.name;
                    if (this.listNamePermissionEdited.includes(roleName)) {
                        setTimeout(() => {
                            this.logout().then(() => {
                                clearInfoUser();
                                this.$router.push('/login');
                            });
                        }, 1000);
                    }
                } else {
                    showMessage(data.code, this.$bvToast, this.$t(data.message));
                }
                this.listNamePermissionEdited = [];
                this.disabled = true;
            });
        },

        onHandleChangePermission(role) {
            this.listNamePermissionEdited.push(role.name);
            this.listNamePermissionEdited = [...new Set(this.listNamePermissionEdited)];
        }
    },
    computed: {
        flattenedPermissions() {
            const groupMapping = {
                campaign: 'キャンペーン管理',
                document: '立ち上げ資料',
                partner_request_sheet: 'パートナー依頼シート',
                prize: '賞品管理',
                return_prize: '賞品戻り管理',
                landing_page: 'LP',
                form: 'フォーム',
                client: 'エンドクライアント',
                partner: '外部パートナー',
                employee: 'パルディア社員',
                permission: '権限',
                master: 'その他',
                history: 'システム管理',
                faq: 'FAQ',
                lottery: '抽選機能'
            };
            const list = [];
            const groups = {};
            this.listDataPermissionRoles.forEach((item) => {
                const prefix = item.name.split('.')[0];
                if (!groups[prefix]) {
                    groups[prefix] = [];
                }
                groups[prefix].push(item);
            });
            Object.keys(groups).forEach((prefix) => {
                groups[prefix].forEach((item, index) => {
                    list.push({
                        ...item,
                        groupLabel: groupMapping[prefix] || prefix,
                        rowSpan: index === 0 ? groups[prefix].length : 0
                    });
                });
            });
            return list;
        }
    }
};
</script>

<template>
    <Layout>
        <div class="row form__common--center" v-if="!isLoading">
            <div class="col-lg-12">
                <div class="card mb-0">
                    <div class="card-header">
                        <h3 class="mb-0 title--screen">権限グループ一覧</h3>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive custom__height--scroll">
                            <table class="table table-striped mb-0 table-bordered custom__table--sticky table-box">
                                <thead>
                                    <tr>
                                        <th style="min-width: 150px" class="text-center">左メニュー</th>
                                        <th style="min-width: 200px" class="text-center">画面</th>
                                        <th
                                            v-for="item in listDataPermission"
                                            :key="'r' + item.id"
                                            style="min-width: 130px; white-space: pre-line"
                                            :class="`${[NAMEROLEFIXED[0].id, NAMEROLEFIXED[1].id].includes(item.id) ? 'text-left' : 'text-center'}`"
                                        >
                                            {{ $t(item.name) }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in flattenedPermissions" :key="item.id" class="group-item">
                                        <td v-if="item.rowSpan > 0" :rowspan="item.rowSpan" class="category-cell">
                                            <div class="font-weight-bold">
                                                {{ item.groupLabel }}
                                            </div>
                                        </td>
                                        <td class="permission-cell">
                                            <div class="row-data-small">
                                                {{ $t(item.name) }}
                                            </div>
                                        </td>
                                        <td v-for="role in listDataPermission" :key="'l' + role.id" class="text-center">
                                            <InputCheckBox
                                                :id="`checkbox__role${role.id}-${item.id}`"
                                                :model.sync="role.per[item.name + '__' + item.id]"
                                                :value="item.id"
                                                :label="``"
                                                :disabled="disabled"
                                                @change="onHandleChangePermission(role)"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Footer>
                <div class="d-flex justify-content-center">
                    <div class="text-center flex-fill">
                        <button
                            type="button"
                            v-if="checkPermiss('permission.register') && disabled"
                            @click="disabled = !disabled"
                            class="btn btn-common btn-primary ml-3"
                        >
                            <i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}
                        </button>
                        <button
                            type="button"
                            v-if="checkPermiss('permission.register') && !disabled"
                            @click="savePermission()"
                            class="btn btn-common btn-success ml-3"
                        >
                            {{ $t('btn.save') }}
                        </button>
                    </div>
                </div>
            </Footer>
        </div>
        <div class="d-flex justify-content-center" v-else>
            <LoadingIcon />
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
.custom__height--scroll {
    height: calc(90vh - 150px - 60px);
}

.table-box {
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #e9ebec;
}
.table-box th {
    background-color: #e6eef5;
    color: #343a40;
}

.category-cell {
    border-bottom: 2px solid #333 !important;
    vertical-align: middle !important;
    text-align: start;
    padding-left: 10px;
    background-color: #f8f9fa;
    color: #343a40;
}

.permission-cell {
    border-bottom: 1px solid #e9ebec;
    vertical-align: middle !important;
    text-align: start;
}

.group-item td {
    border-bottom: 1px solid #e9ebec;
}

/* Add thick border at the end of each group */
.group-item:has(+ .group-item .category-cell) td,
.group-item:last-child td {
    border-bottom: 2px solid #333 !important;
}

.group-item td:not(.category-cell) {
    border-left: 2px solid #e9ebec;
}

/* First row special case for top border */
.group-item:first-child .category-cell,
.group-item:first-child td {
    border-top: 2px solid #333 !important;
}
</style>
